import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { interval, Observable, Subscription } from 'rxjs';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import * as $ from "jquery";
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { NearbyVehTripInfoComponent } from '../nearby-veh-trip-info/nearby-veh-trip-info.component';
declare let google: any;
declare let L;
import * as L from 'leaflet';

@Component({
  selector: 'app-route-deviation-alert',
  templateUrl: './route-deviation-alert.component.html',
  styleUrls: ['./route-deviation-alert.component.scss']
})
export class RouteDeviationAlertComponent {

  mapCenter: any;
  tripListData: any[] = [];
  employeeStats: any[] = [];
  map: any = {};
  maps: any[] = [];
  marker: any;
  tripempmarkers: any = [];
  sitemarker: any;
  markers: any = [];
  colours = ["#4B0082"];
  sub: Subscription;
  isZoomed: Boolean = false;
  showGoogleMap = false;
  isOsm = false;
  googleMapInitialized = false;
  mapLoadAttempts = 0;
  maxMapLoadAttempts = 50;
  dialogData: any = {};
  reason: any;
  _mCurrentUser: any;
  private markers1: L.Marker[] = [];
  private vehicleMarkers: { [tripIndex: number]: L.Marker } = {};

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RouteDeviationAlertComponent>,
    private serviceLocalStorage: ServiceLocalStorage,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,) {

    this.dialogData = data.tripData;
    this.tripListData = this.dialogData;
    this.calculateEmployees(this.dialogData);
    // if (data.mapType === AppConstants.OSRM) {
    //   this.map = {};
    //   setTimeout(() => {
    //     this.loadOSmap();
    //     this.showTripOnOSMap();
    //     this.plotVehicle();
    //   }, 10);
    // } else {
    //   google.maps.event.addDomListener(window, "load", this.initMap());
    // }
  }

  ngOnInit() {
    this._mCurrentUser = this.serviceLocalStorage.getUserObject();
    this.resolveMapTypeAndInit();
  }

  /** Uses client master-config flag (same as panic-action-notification). */
  private resolveMapTypeAndInit(): void {
    const clientCode = localStorage.getItem('clientCode');
    if (!clientCode) {
      this.initMapByClientFlag();
      return;
    }
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getMapType + clientCode,
      success => {
        if (success.status === 200) {
          this.serviceLocalStorage.setGoogleMapTypeEnabled(!!success.body?.isGoogleMapEnabled);
        }
        this.initMapByClientFlag();
      },
      () => this.initMapByClientFlag()
    );
  }

  private initMapByClientFlag(): void {
    this.showGoogleMap = this.serviceLocalStorage.isSetGoogleMapTypeEnabled();
    this.isOsm = !this.showGoogleMap;
    this.googleMapInitialized = false;
    this.mapLoadAttempts = 0;
    setTimeout(() => {
      if (this.isOsm) {
        this.map = {};
        this.loadOSmap();
        this.showTripOnOSMap();
        this.plotVehicle();
      } else {
        this.loadgmap();
      }
    }, 10);
  }

  plotVehicle() {
    this.getVehiclePosition(false);
    this.sub = interval(3000).subscribe(val => {
      this.getVehiclePosition(true);
    });
  }

  loadOSmap() {
    this.map = L.map("deviationTripMap" + this.tripListData[0].tripDetails.tripId, {
      fullscreenControl: true
    }).setView([
      this.tripListData[0].tripDetails.site.landmark.latitude,
      this.tripListData[0].tripDetails.site.landmark.longitude
    ], 13);
    L.tileLayer(AppConstants.OSM_TILE, { attribution: AppConstants.OSM_CONTRIBUTORS }).addTo(this.map);
  }

  showTripOnOSMap() {
    if (this.tripListData[0].tripDetails.tripCode.indexOf('SPL') == -1) {
      let wps = [];
      if (this.tripListData[0].tripDetails.shift.logType == "IN") {
        this.tripListData[0].tripDetails.tripUsers.forEach(wp => {
          wps.push(L.latLng(wp.landmark.latitude, wp.landmark.longitude));
        });
        wps.push(
          L.latLng(
            this.tripListData[0].tripDetails.site.landmark.latitude,
            this.tripListData[0].tripDetails.site.landmark.longitude
          ));
      } else {
        wps.push(
          L.latLng(
            this.tripListData[0].tripDetails.site.landmark.latitude,
            this.tripListData[0].tripDetails.site.landmark.longitude
          ));
        this.tripListData[0].tripDetails.tripUsers.forEach(wp => {
          wps.push(L.latLng(wp.landmark.latitude, wp.landmark.longitude));
        });
      }
      let r = L.Routing.control({
        serviceUrl: AppConstants.OSM_ROUTING_URL,
        showAlternatives: false,
        lineOptions: {
          styles: [
            {
              color: "#242c81",
              weight: 7
            }
          ]
        },
        fitSelectedRoutes: true,
        waypointMode: "connect",
        addWaypoints: false,
        draggableWaypoints: false,
        autoRoute: true,
        reverseWaypoints: false,
        altLineOptions: {
          styles: [
            {
              color: "#ed6852",
              weight: 3
            }
          ]
        },
        show: true,
        routeWhileDragging: false,
        createMarker: (i, wp, nWps) => {
          if (this.tripListData[0].tripDetails.shift.logType === "IN") {
            if (i === this.tripListData[0].tripDetails.tripUsers.length) {
              let m = L.marker(wp.latLng, {
                icon: L.icon({
                  iconUrl: "./assets/images/company.png",
                  iconSize: [40, 40]
                }),
                title: this.tripListData[0].tripDetails.site.landmark.landmark
              });
              return m;
            }
          } else {
            if (i === 0) {
              let m = L.marker(wp.latLng, {
                icon: L.icon({
                  iconUrl: "./assets/images/company.png",
                  iconSize: [40, 40]
                }),
                title: this.tripListData[0].tripDetails.site.landmark.landmark
              });
              return m;
            }
          }
          if (this.tripListData[0].tripDetails.shift.logType === "IN") {
            if (i <= this.tripListData[0].tripDetails.tripUsers.length) {
              let m = L.marker(wp.latLng, {
                icon: L.icon({
                  iconUrl:
                    this.tripListData[0].tripDetails.tripUsers[i].tripUser.userInfoDetails.gender === "Female"
                      ? "./assets/images/livetracking/femaleloc.svg"
                      : "./assets/images/livetracking/maleloc.svg",
                  iconSize: [65, 70]
                }),
                title: this.tripListData[0].tripDetails.tripUsers[i].tripUser.userInfoDetails.displayName
              }).bindTooltip(i + 1 + "", {
                permanent: true,
                direction: "left",
                offset: L.point(-10, 0)
              }).openTooltip();
              return m;
            }
          } else {
            if (i - 1 <= this.tripListData[0].tripDetails.tripUsers.length) {
              let m = L.marker(wp.latLng, {
                icon: L.icon({
                  iconUrl:
                    this.tripListData[0].tripDetails.tripUsers[i - 1].tripUser.userInfoDetails.gender === "Female"
                      ? "./assets/images/livetracking/femaleloc.svg"
                      : "./assets/images/livetracking/maleloc.svg",
                  iconSize: [65, 70]
                }),
                title: this.tripListData[0].tripDetails.tripUsers[i - 1].tripUser.userInfoDetails.displayName
              })
                .bindTooltip(i + "", {
                  permanent: true,
                  direction: "left",
                  offset: L.point(-10, 0)
                })
                .openTooltip();
              return m;
            }
          }
        }
      }).addTo(this.map);
      r.setWaypoints(wps);
      r.hide();
    }
  }

  initMap() {
    this.loadgmap();
  }

  loadgmap(): void {
    if (!this.showGoogleMap || this.isOsm) {
      return;
    }
    if (this.googleMapInitialized && this.maps?.length) {
      return;
    }
    if (!this.tripListData) {
      this.dialogRef.close("NoTrips");
      return;
    }
    const mapEl = document.getElementById('deviationTripMap' + this.tripListData[0].tripDetails.tripId);
    if (!mapEl) {
      this.scheduleGoogleMapLoadRetry();
      return;
    }
    if (typeof google === 'undefined' || (!google.maps?.Map && !google.maps?.importLibrary)) {
      this.scheduleGoogleMapLoadRetry();
      return;
    }
    this.initGoogleMapAsync();
  }

  private scheduleGoogleMapLoadRetry(): void {
    if (++this.mapLoadAttempts >= this.maxMapLoadAttempts) {
      return;
    }
    setTimeout(() => this.loadgmap(), 100);
  }

  private async initGoogleMapAsync(): Promise<void> {
    if (this.googleMapInitialized && this.maps?.length) {
      return;
    }
    try {
      let MapClass = google.maps?.Map;
      if (google.maps?.importLibrary) {
        const mapsLib = await google.maps.importLibrary('maps') as any;
        MapClass = mapsLib.Map;
      }
      if (!MapClass) {
        this.scheduleGoogleMapLoadRetry();
        return;
      }
      const latlng = {
        lat: Number(this.tripListData[0].tripDetails.site.landmark.latitude),
        lng: Number(this.tripListData[0].tripDetails.site.landmark.longitude)
      };
      this.maps = [];
      this.tripListData.forEach((trip, t) => {
        const mapElement = document.getElementById('deviationTripMap' + trip.tripDetails.tripId);
        if (!mapElement) {
          return;
        }
        this.mapCenter = latlng;
        const map = new MapClass(mapElement, {
          center: latlng,
          zoom: 13,
          draggable: true,
          zoomControl: true,
          gestureHandling: 'greedy'
        });
        this.maps.push(map);
        this.markSite(this.tripListData[0].tripDetails.site, t);
        google.maps.event.addListenerOnce(map, 'idle', () => {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(latlng);
        });
      });
      if (!this.maps.length) {
        this.scheduleGoogleMapLoadRetry();
        return;
      }
      this.googleMapInitialized = true;
      this.showRoutesOnMap();
      this.plotVehicle();
    } catch (error) {
      console.error('Google Map init failed', error);
      this.scheduleGoogleMapLoadRetry();
    }
  }

  // initMap() {
  //   ... old sync google.maps.Map on panicTripMap id (wrong element)
  // }

  markSite(site, mapIndex) {
    const sitecordinates = new google.maps.LatLng(
      site.landmark.latitude,
      site.landmark.longitude
    );
    const path = "./assets/images/company.png";
    this.sitemarker = new google.maps.Marker({
      position: sitecordinates,
      icon: {
        url: path,
        scaledSize: new google.maps.Size(40, 40)
      },
      map: this.maps[mapIndex],
      title: site.siteName
    });
  }

  getVehiclePosition(iterate) {
    this.tripListData.forEach((trip, t) => {
      const body = {
        clientCode: this._mCurrentUser.clientCode
      };
      // this.apiService.doPostRequestWithResponseForLiveTracking('fetchallgeoposition?tripId=' + trip.tripDetails.tripId + '&maptype=' + (this.isOsm ? this.serviceLocalStorage.maptype : AppConstants.OSRM), body, success => {
      this.apiService.doPostRequestWithResponseForLiveTracking('fetchallgeoposition?tripId=' + trip.tripDetails.tripId + '&maptype=' + (this.isOsm ? this.serviceLocalStorage.maptype : 'GOOGLE'), body, success => {
        if (this.isOsm) {
          this.plotVehicleMarkerOnOSmap(success.body, t);
        } else {
          if (iterate) {
            this.setVehiclePosition(success, t);
            if (!this.isZoomed) {
              this.setZoomForCab();
            }
          } else {
            this.plotVehicleMarker(success.body, t);
          }
        }
      }, error => {
        this.notifyService.showError(error, null);
      });
    });
  }

  /** Live-track API returns positionList (Google) or waypoints (OSRM). */
  private getVehiclePositions(veh: any): any[] {
    // Google maptype payload uses positionList + mobileTime, not waypoints/time
    // if (Array.isArray(veh?.waypoints) && veh.waypoints.length) {
    //   return veh.waypoints;
    // }
    if (Array.isArray(veh?.positionList) && veh.positionList.length) {
      return veh.positionList;
    }
    if (Array.isArray(veh?.waypoints) && veh.waypoints.length) {
      return veh.waypoints;
    }
    return [];
  }

  plotVehicleMarker(veh, tripIndex) {
    const positions = this.getVehiclePositions(veh);
    if (!positions.length || !this.maps[tripIndex]) {
      return;
    }
    const last = positions[positions.length - 1];
    const latlng = {
      lat: Number(last.latitude),
      lng: Number(last.longitude)
    };
    this.maps[tripIndex].panTo(latlng);
    const marker = new google.maps.Marker({
      position: latlng,
      animation: google.maps.Animation.DROP,
      draggable: false,
      icon: {
        url: "./assets/images/livetracking/vehicle/FF503F.png?id=" + veh.tripId,
        scaledSize: new google.maps.Size(45, 40),
        anchor: new google.maps.Point(15, 20)
      },
      map: this.maps[tripIndex]
    });
    marker.customData = veh;
    this.markers.push(marker);
  }


  setZoomForCab() {
    this.tripListData.forEach((t, tripIndex) => {
      this.maps[tripIndex].setCenter(this.markers[tripIndex].position);
      this.maps[tripIndex].setZoom(17);
    });
    this.isZoomed = true;
  }

  setVehiclePosition(data, tripIndex) {
    const vehiclePlanCoordinates = [];
    if (data.body) {
      this.showRunningVehicle(data, tripIndex);
      this.getVehiclePositions(data.body).forEach(vehicle => {
        vehiclePlanCoordinates.push({
          lat: vehicle.latitude,
          lng: vehicle.longitude
        });
      });
      if (!vehiclePlanCoordinates.length) {
        return;
      }
      const flightPath = new google.maps.Polyline({
        path: vehiclePlanCoordinates,
        geodesic: true,
        strokeColor: "#FF0000",
        strokeOpacity: 1.0,
        strokeWeight: 2
      });
      flightPath.setMap(this.maps[tripIndex]);
    }
  }

  setVehiclePositionOnOSmap(data, tripIndex) {
    const vehiclePlanCoordinates = [];
    if (data.body) {
      this.showRunningVehicle(data, tripIndex);
      data.body.positionList.forEach(vehicle => {
        vehiclePlanCoordinates.push({
          lat: vehicle.latitude,
          lng: vehicle.longitude
        });
      });
      const flightPath = new google.maps.Polyline({
        path: vehiclePlanCoordinates,
        geodesic: true,
        strokeColor: "#FF0000",
        strokeOpacity: 1.0,
        strokeWeight: 2
      });
      flightPath.setMap(this.maps[tripIndex]);
    }
  }

  showRunningVehicle(data, tripIndex) {
    const positions = this.getVehiclePositions(data.body);
    if (!positions.length) {
      return;
    }
    const lastPosition = positions.length - 1;
    this.markers.forEach(m => {
      if (m.customData.tripId === this.tripListData[tripIndex].tripDetails.tripId) {
        const prevPosn = m.getPosition();
        const newPosition = new google.maps.LatLng(
          positions[lastPosition].latitude,
          positions[lastPosition].longitude
        );
        const direction = this.computeHeadingDegrees(prevPosn, newPosition);
        m.setPosition(newPosition);
        this.maps[tripIndex]?.panTo(newPosition);
        $('img[src="./assets/images/livetracking/vehicle/FF503F.png?id=' + data.body.tripId + '"]').css({
          transform: "rotate(" + direction + "deg)",
          transition: "all 1s ease"
        });
        const icon = m.getIcon();
        if (icon) {
          icon.rotation = direction;
          m.setIcon(icon);
        }
      }
    });
    this.fetchETA(tripIndex, positions);
  }

  private computeHeadingDegrees(from: any, to: any): number {
    const lat1 = (typeof from.lat === 'function' ? from.lat() : from.lat) * Math.PI / 180;
    const lat2 = (typeof to.lat === 'function' ? to.lat() : to.lat) * Math.PI / 180;
    const dLng = ((typeof to.lng === 'function' ? to.lng() : to.lng) -
      (typeof from.lng === 'function' ? from.lng() : from.lng)) * Math.PI / 180;
    const y = Math.sin(dLng) * Math.cos(lat2);
    const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
    return (Math.atan2(y, x) * 180 / Math.PI + 360) % 360;
  }

  fetchETA(tripIndex, vehiclePos) {
    let destLat, destLng;
    if (this.tripListData[tripIndex].tripDetails.shift.logType == "IN") {
      destLat = this.tripListData[tripIndex].tripDetails.tripUsers[0]
        ? this.tripListData[tripIndex].tripDetails.tripUsers[0].landmark.latitude : this.tripListData[tripIndex].tripDetails.site.landmark.latitude;
      destLng = this.tripListData[tripIndex].tripDetails.tripUsers[0]
        ? this.tripListData[tripIndex].tripDetails.tripUsers[0].landmark.longitude : this.tripListData[tripIndex].tripDetails.site.landmark.longitude;
    } else {
      destLat = this.tripListData[tripIndex].tripDetails.tripUsers[this.tripListData[tripIndex].tripDetails.tripUsers.length - 1].landmark.latitude;
      destLng = this.tripListData[tripIndex].tripDetails.tripUsers[this.tripListData[tripIndex].tripDetails.tripUsers.length - 1].landmark.longitude;
    }
    const body = {
      tripid: this.tripListData[tripIndex].tripDetails.tripId,
      srcLat: vehiclePos[vehiclePos.length - 1].latitude,
      srcLong: vehiclePos[vehiclePos.length - 1].longitude,
      destLat: destLat,
      destLong: destLng
    };
    this.apiService.doPostRequestWithResponse(ApiConstants.fetcheta, body, success => {
      if (success.body.tripid === this.tripListData[tripIndex].tripDetails.tripId) {
        this.tripListData[tripIndex].etaKm = success.body.distance ? success.body.distance : 0;
        this.tripListData[tripIndex].etaMin = success.body.time ? success.body.time : "NA";
        this.tripListData[tripIndex].consumedMin = success.body.timeElapsed ? success.body.timeElapsed.slice(3, 8) : "NA";
        this.tripListData[tripIndex].consumedKm = success.body.distanceCovered ? success.body.distanceCovered : 0;
        this.tripListData[tripIndex].lateTime = success.body.lateTime ? success.body.lateTime : 0;
      }
    }, error => {
      this.notifyService.showError(error, null);
    });
  }

  plotVehicleMarkerOnOSmap(veh, tripIndex) {
    this.map.panTo(
      new L.LatLng(
        veh.waypoints[veh.waypoints.length - 1].latitude,
        veh.waypoints[veh.waypoints.length - 1].longitude
      )
    );
    let carMarker = new L.Icon({
      iconUrl: "./assets/images/livetracking/vehicle/FF503F.png",
      iconSize: [45, 40],
      iconAnchor: [15, 20]
    });

    if (this.vehicleMarkers[tripIndex]) {
      this.map.removeLayer(this.vehicleMarkers[tripIndex]);
    }

    this.vehicleMarkers[tripIndex] = L.marker([veh.waypoints[veh.waypoints.length - 1].latitude,
    veh.waypoints[veh.waypoints.length - 1].longitude], { icon: carMarker }).addTo(this.map);
  }

  showRoutesOnMap() {
    this.tripListData.forEach((trip, t) => {
      if (trip.tripDetails.tripCode?.includes('SPL')) {
        return;
      }
      let waypts = [];
      let startnodelatlng = {
        lat: trip.tripDetails.site.landmark.latitude,
        lng: trip.tripDetails.site.landmark.longitude
      };
      let endnodelatlng = {
        lat: trip.tripDetails.site.landmark.latitude,
        lng: trip.tripDetails.site.landmark.longitude
      };
      if (trip.tripDetails.shift) {
        if (trip.tripDetails.shift.logType == "IN") {
          startnodelatlng = {
            lat: trip.tripDetails.tripUsers[0] ? trip.tripDetails.tripUsers[0].showStatus == "SHOW" ? trip.tripDetails.tripUsers[0].booardedLatitude
              ? trip.tripDetails.tripUsers[0].booardedLatitude : trip.tripDetails.tripUsers[0].landmark.latitude
              : trip.tripDetails.tripUsers[0].landmark.latitude : trip.tripDetails.site.landmark.latitude,
            lng: trip.tripDetails.tripUsers[0] ? trip.tripDetails.tripUsers[0].showStatus == "SHOW" ? trip.tripDetails.tripUsers[0].booardedLongitude
              ? trip.tripDetails.tripUsers[0].booardedLongitude : trip.tripDetails.tripUsers[0].landmark.longitude
              : trip.tripDetails.tripUsers[0].landmark.longitude : trip.tripDetails.site.landmark.longitude
          };
        } else {
          const tripLength = trip.tripDetails.tripUsers.length - 1;
          endnodelatlng = {
            lat: trip.tripDetails.tripUsers[tripLength].showStatus == "SHOW" ? trip.tripDetails.tripUsers[tripLength].arrivalLatitude
              ? trip.tripDetails.tripUsers[tripLength].arrivalLatitude : trip.tripDetails.tripUsers[tripLength].landmark.latitude
              : trip.tripDetails.tripUsers[tripLength].landmark.latitude,
            lng: trip.tripDetails.tripUsers[tripLength].showStatus == "SHOW" ? trip.tripDetails.tripUsers[tripLength].arrivalLongitude
              ? trip.tripDetails.tripUsers[tripLength].arrivalLongitude : trip.tripDetails.tripUsers[tripLength].landmark.longitude
              : trip.tripDetails.tripUsers[tripLength].landmark.longitude
          };
        }
      }
      let markerlist = [];
      trip.tripDetails.tripUsers.forEach((tripuser, tIndex) => {
        waypts.push({
          location: {
            lat: tripuser.showStatus == "SHOW" && trip.tripDetails.shift.logType == "IN" ? tripuser.booardedLatitude ? tripuser.booardedLatitude
              : tripuser.landmark.latitude : tripuser.landmark.latitude,
            lng: tripuser.showStatus == "SHOW" && trip.tripDetails.shift.logType == "IN" ? tripuser.booardedLongitude ? tripuser.booardedLongitude
              : tripuser.landmark.longitude : tripuser.landmark.longitude
          },
          stopover: true
        });
        const empLat = tripuser.showStatus == "SHOW" && trip.tripDetails.shift.logType == "IN" ? tripuser.booardedLatitude ? tripuser.booardedLatitude
          : tripuser.landmark.latitude : tripuser.landmark.latitude;
        const empLng = tripuser.showStatus == "SHOW" && trip.tripDetails.shift.logType == "IN" ? tripuser.booardedLongitude ? tripuser.booardedLongitude
          : tripuser.landmark.longitude : tripuser.landmark.longitude;
        const iconUrl = tripuser.tripUser.userInfoDetails.gender == "Female"
          ? "./assets/images/livetracking/femaleloc.svg"
          : "./assets/images/livetracking/maleloc.svg";
        var marker = new google.maps.Marker({
          position: { lat: empLat, lng: empLng },
          icon: {
            url: iconUrl,
            scaledSize: new google.maps.Size(40, 44),
            anchor: new google.maps.Point(20, 44)
          },
          draggable: false,
          map: this.maps[t],
          title: tripuser.tripUser.userInfoDetails.displayName + " - " + tripuser.routedOrder
        });
        marker.customData = {
          tripId: trip.tripDetails.tripId,
          tripIndex: t,
          logType: trip.tripDetails.shift.logType,
          userId: tripuser.tripUser.userInfoDetails.id,
          tripUser: tripuser
        };
        this.createOsmLikeLabel(this.maps[t], { lat: empLat, lng: empLng }, String(tIndex + 1), 'left');
        google.maps.event.addListener(marker, "click", () => {
          this.fetchUserHomePickup(marker.customData);
        });
        markerlist.push(marker);
      });
      this.tripempmarkers.push({
        tripid: trip.tripDetails.tripId,
        markers: markerlist
      });
      if (this.sitemarker == undefined) {
        this.markSite(trip.tripDetails.site, t);
      }
      const isInTrip = trip.tripDetails.shift?.logType == "IN";
      // Exclude origin/destination from waypoints — duplicating them skews Google Directions.
      const middleWaypts = isInTrip ? waypts.slice(1) : waypts.slice(0, -1);
      let request = {
        origin: startnodelatlng,
        destination: endnodelatlng,
        waypoints: middleWaypts,
        optimizeWaypoints: false,
        avoidHighways: false,
        avoidTolls: false,
        travelMode: google.maps.DirectionsTravelMode.DRIVING
      };
      let directionsService = new google.maps.DirectionsService();
      let directionsDisplay = new google.maps.DirectionsRenderer({
        polylineOptions: {
          strokeColor: "#242c81",
          strokeWeight: 7,
          strokeOpacity: 1
        }
      });
      directionsDisplay.setMap(this.maps[t]);
      directionsDisplay.setOptions({ suppressMarkers: true });
      directionsService.route(request, (response, status) => {
        if (status == google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(response);
        }
      });
    });
  }

  fetchUserHomePickup(userData) {
    this.apiService.doGetRequestWithResponse(ApiConstants.fetchuserhomepickup + userData.tripId + "&userId=" + userData.userId + "&logType=" + userData.logType, success => {
      this.setPickupPoint(userData, success.body);
      this.setHomePoint(userData, success.body);
    }, error => {
      this.notifyService.showError(error, null);
    }
    );
  }

  setHomePoint(userData, data) {
    this.addMarker(userData, data, "home");
    this.setRoute(userData, data, "home");
  }

  setPickupPoint(userData, data) {
    this.addMarker(userData, data, "pickup");
    this.setRoute(userData, data, "pickup");
  }

  addMarker(userData, data, type) {
    var marker = new google.maps.Marker({
      position: {
        lat: type == "home" ? data.homeLandmark.latitude : data.pickupLandmark.latitude,
        lng: type == "home" ? data.homeLandmark.longitude : data.pickupLandmark.longitude
      },
      icon: type == "home" ? "./assets/images/home.png" : "./assets/images/livetracking/driver.png",
      draggable: false,
      map: this.maps[userData.tripIndex],
      title: data.homeLandmark.area.area
    });
  }

  setRoute(userData, data, type) {
    let startnodelatlng = {
      lat: userData.tripUser.showStatus == "SHOW" ? userData.tripUser.booardedLatitude : userData.tripUser.landmark.latitude,
      lng: userData.tripUser.showStatus == "SHOW" ? userData.tripUser.booardedLongitude : userData.tripUser.landmark.longitude
    };
    let endnodelatlng = {
      lat: type == "home" ? data.homeLandmark.latitude : data.pickupLandmark.latitude,
      lng: type == "home" ? data.homeLandmark.longitude : data.pickupLandmark.longitude
    };
    let request = {
      origin: startnodelatlng,
      destination: endnodelatlng,
      waypoints: [],
      optimizeWaypoints: false,
      avoidHighways: false,
      avoidTolls: false,
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    };
    let directionsService = new google.maps.DirectionsService();
    let directionsDisplay = new google.maps.DirectionsRenderer({
      preserveViewport: true,
      polylineOptions: {
        strokeColor: type === "home" ? "#080" : "#800", //t
        strokeWeight: 3,
        strokeOpacity: 0.7
      }
    });
    directionsDisplay.setMap(this.maps[userData.tripIndex]);
    directionsDisplay.setOptions({ suppressMarkers: true });
    directionsService.route(request, (response, status) => {
      if (status == google.maps.DirectionsStatus.OK) {
        directionsDisplay.setDirections(response);
      }
    });
  }

  doIVRCall(userId, tripId, empType) {
    this.ngxLoader.start();
    const endpoint = empType === 'driver' ? `&driverId=${userId}` :
      empType === 'escort' ? `&escortId=${userId}` :
        `&tripUserId=${userId}`;

    this.apiService.doPostRequestWithResponse(ApiConstants.routeDeviationCall + tripId + endpoint, '', (success) => {
      this.ngxLoader.stop();
      if (success.status == 200 && success.body.message == 'Success') {
      } else {
        this.notifyService.showWarning(success.body.message, null);
      }
    }, (error) => {
      this.ngxLoader.stop();
      console.log(error);
    });
  }

  updateRemark(tripId) {
    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(ApiConstants.deviationRemark + tripId + '&remark=' + this.reason, '', success => {
      this.ngxLoader.stop();
      if (success.body && success.body.message == 'Updated successfully') {
        this.notifyService.showSuccess(success.body.message, null);
        this.dialogRef.close();
      } else {
        this.notifyService.showWarning(success.body.message, null);
      }
    },
      error => {
        this.ngxLoader.stop();
        this.notifyService.showError(error, null);
      });
  }

  calculateEmployees(trips) {
    trips.forEach((trip, t) => {
      this.employeeStats.push({
        femaleEmployees: 0,
        maleEmployees: 0,
        totalEmployees: 0,
        femaleShowStats: 0,
        maleShowStats: 0,
        femaleNoShowStats: 0,
        maleNoShowStats: 0,
        currentLocationPin: 0
      });
      this.employeeStats[t].totalEmployees = trip.tripDetails.tripUsers.length;
      trip.tripDetails.tripUsers.forEach((emp, e) => {
        emp.showStatus === "SHOW" ? (this.employeeStats[t].currentLocationPin = e + 1) : "";
        if (emp.tripUser.userInfoDetails.gender === "Female") {
          this.employeeStats[t].femaleEmployees++;
          if (emp.showStatus === "SHOW") {
            this.employeeStats[t].femaleShowStats++;
          }
          if (emp.showStatus === "NO SHOW") {
            this.employeeStats[t].femaleNoShowStats++;
          }
        } else {
          this.employeeStats[t].maleEmployees++;
          if (emp.showStatus === "SHOW") {
            this.employeeStats[t].maleShowStats++;
          }
          if (emp.showStatus === "NO SHOW") {
            this.employeeStats[t].maleNoShowStats++;
          }
        }
      });
    });
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }

  /** Leaflet-style permanent tooltip (stop numbers) on Google Maps. */
  private createOsmLikeLabel(
    map: any,
    position: { lat: number; lng: number },
    text: string,
    placement: 'left' | 'top' = 'top',
    onClick?: () => void
  ): any {
    if (!map || !google?.maps?.OverlayView || !text) {
      return null;
    }
    const Overlay = google.maps.OverlayView;
    class OsmLikeLabel extends Overlay {
      div: HTMLDivElement | null = null;
      pos: any;
      labelText: string;
      labelPlacement: 'left' | 'top';
      clickHandler?: () => void;

      constructor(pos: any, labelText: string, labelPlacement: 'left' | 'top', clickHandler?: () => void) {
        super();
        this.pos = pos;
        this.labelText = labelText;
        this.labelPlacement = labelPlacement;
        this.clickHandler = clickHandler;
      }

      onAdd() {
        const div = document.createElement('div');
        div.className = this.labelPlacement === 'left'
          ? 'gm-leaflet-tooltip gm-leaflet-tooltip-left'
          : 'gm-leaflet-tooltip gm-leaflet-tooltip-top';
        const safe = String(this.labelText || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
        div.innerHTML = `<b>${safe}</b>`;
        if (this.clickHandler) {
          div.addEventListener('click', (e) => {
            e.stopPropagation();
            this.clickHandler();
          });
        }
        this.div = div;
        this.getPanes()?.overlayMouseTarget?.appendChild(div);
      }

      draw() {
        if (!this.div) return;
        const projection = this.getProjection();
        if (!projection) return;
        const point = projection.fromLatLngToDivPixel(this.pos);
        if (!point) return;
        this.div.style.left = `${point.x}px`;
        this.div.style.top = this.labelPlacement === 'left'
          ? `${point.y - 22}px`
          : `${point.y - 20}px`;
      }

      onRemove() {
        if (this.div?.parentNode) {
          this.div.parentNode.removeChild(this.div);
        }
        this.div = null;
      }
    }

    const overlay = new OsmLikeLabel(
      new google.maps.LatLng(position.lat, position.lng),
      text,
      placement,
      onClick
    );
    overlay.setMap(map);
    return overlay;
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    // Clear markers to prevent memory leaks
    this.markers.forEach(marker => marker.setMap(null));
    this.tripempmarkers.forEach(trip =>
      trip.markers.forEach(marker => marker.setMap(null))
    );
    this.markers = [];
    this.tripempmarkers = [];
  }

}
